export default __webpack_public_path__ + "static/media/sledz-nas-desktop.fbd46498.jpg";